module.exports = __webpack_public_path__ + "static/media/Poppins-BoldItalic.b10e7a6e.ttf";